<template>
    <rkm-form ref="RkmForm">
        <rkm-row>
            <rkm-col
                v-if="hasKitsExames()"
                class="rkm-col"
                cols="3"
            >
                <rkm-area
                    title="Kit de Exames"
                    type="section"
                >
                    <rkm-form-checkbox
                        v-for="(kit, i) in data.form.kits"
                        v-bind:key="`rkm-form-checkbox-kit-${i}`"
                        :class="'rkm-form-checkbox' + (i === data.form.kits.length - 1 ? '' : ' mb-1')"
                        :id="'popover-' + i"
                        :indeterminate="handleIndeterminate(kit)"
                        @change.native="handleKitChange($event, kit)"
                        v-model="kit.checked"
                    >
                        {{ kit.nome }}
                    </rkm-form-checkbox>

                    <rkm-popover
                        v-for="(kit, i) in data.form.kits"
                        v-bind:key="i"
                        :target="'popover-' + i"
                        triggers="hover"
                    >
                        <div class="rkm-popover">
                            <rkm-form-checkbox
                                v-for="(exame, j) in kit.exames"
                                v-bind:key="`rkm-form-checkbox-exame-${j}`"
                                :class="'rkm-form-checkbox' + (j === kit.exames.length - 1 ? '' : ' mb-1')"
                                v-model="exame.checked"
                                @change.native="handleItemKitChange($event, exame)"
                            >
                                {{ exame.nome }}
                            </rkm-form-checkbox>
                        </div>
                    </rkm-popover>
                </rkm-area>
            </rkm-col>

            <rkm-col :cols="hasKitsExames() ? 9 : 12">
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :requestQueryStringParams="autocompleteQueryStringParams.exame"
                            :searchFields="fields.exame"
                            :repository="repositories.exame"
                            label="Exame"
                            v-model="model.exame"
                        >
                            <template v-slot:itemLabel="{ item }">
                                {{ item.codigo | formatProcedimento }} - {{ item.nome }}
                            </template>
                        </rkm-form-input-autocomplete>
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-button
                            class="mt-4"
                            color="primary"
                            @click="handleAdd"
                        >
                            Incluir
                        </rkm-button>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-list
                            :items="model.exames"
                            hide-filters
                            hide-pagination
                        >
                            <template v-slot="{ item }">
                                {{ item.nome }}
                            </template>

                            <template v-slot:trailling="{ item }">
                                <rkm-button
                                    @click.stop="handleDestroy(item)"
                                    color="danger"
                                    title="Excluir"
                                    small
                                >
                                    <rkm-icon icon="trash" />
                                </rkm-button>
                            </template>
                        </rkm-list>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-textarea
                            :validations="validations.justificativa"
                            label="Justificativa da solicitação"
                            v-model="model.justificativa"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-checkbox v-model="model.urgente">
                            Urgente
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
//Enums
import statusExame from '@/enums/pronto-atendimento/statusExame'

// Filters.
import formats from '@/filters/formats'

// Mixins.
import { repository, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        autocompleteQueryStringParams() {

            return {
                exame: { cbo_lotacao_atual: true, only_filter_exame_imagem_cbo: true },
            }
        },
        fields() {

            return {
                exame: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                    { key: 'parametrizacao_procedimento.apelido', searchable: true },
                ]
            }
        },
        validations() {
            return {
                exame: {
                    id: { required: true },
                },
                justificativa: { max: 100 },
            }
        },
    },
    created() {
        this.repositories = {
            exame: this.getConectaSusRepository('parametrizacao.exame'),
            dataHora: this.getConectaSusRepository('dataHora')
        }
    },
    data: () => ({
        enums: {
            statusExame
        },
    }),
    filters: {
        ...formats,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleIndeterminate(kit) {
            const indeterminate = kit.exames.some(exameKit => {
                return !!this.model.exames.find(examePedido => examePedido.id === exameKit.id)
            })

            const checked = kit.exames.every(exameKit => {
                return !!this.model.exames.find(examePedido => examePedido.id === exameKit.id)
            })

            if (indeterminate === true && checked === false) {
                return true
            }

            kit.checked = checked

            return false
        },
        handleKitChange(event, kit) {

            const { checked } = event.target

            if (checked) {

                kit.exames.map(exame => {

                    if (!this.model.exames.find(e => e.id === exame.id)) {

                        exame.checked = true

                        this.model.exames.push(this.prepareExame(exame))
                    }
                })
            }
            else {

                kit.exames.map(exame => {

                    const index = this.model.exames.findIndex(e => e.id === exame.id)

                    if (index >= 0) {

                        exame.checked = false

                        this.model.exames.splice(index, 1)
                    }
                })
            }
        },
        handleItemKitChange(event, exame) {

            const { checked } = event.target

            if (checked) {

                exame.checked = true

                this.model.exames.push(this.prepareExame(exame))
            }
            else {

                exame.checked = false

                const index = this.model.exames.findIndex(e => e.id === exame.id)

                this.model.exames.splice(index, 1)
            }
        },
        handleAdd() {
            if (this.model.exame === null) {
                this.createNotification({
                    type: 'alert',
                    color: 'danger',
                    title: 'Ação não permitida',
                    message: 'Selecione um exame.'
                })
            } else {
                const duplicado = this.model.exames.find(item => {
                    return item.id === this.model.exame.id
                })

                if (duplicado) {
                    this.createNotification({
                        type: 'alert',
                        color: 'danger',
                        title: 'Ação não permitida',
                        message: 'Exame já incluído na solicitação!'
                    })
                } else {

                    this.data.form.kits.map(k => k.exames
                        .map(e => e.id === this.model.exame.id && (e.checked = true)))

                    this.model.exames.push(this.prepareExame(this.model.exame))
                    this.model.exame = null
                }
            }
        },
        prepareExame(exameKit) {

            const exame = this.clone(exameKit)

            exame.dataSolicitacao = ''

            exame.status = {
                id: this.enums.statusExame.SOLICITADO,
                nome: 'SOLICITADO'
            }

            delete exame.checked

            return exame
        },
        handleDestroy(item) {

            const destroy = async () => {

                this.data.form.kits.map(k => k.exames.map(e => e.id === item.id && (e.checked = false)))
                this.model.exames.splice(this.model.exames.findIndex(exame => exame.id === item.id), 1)
            }

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        },
        hasKitsExames() {

            return this.data.form.kits.length > 0
        },
        save() {
            this.$refs.RkmForm.validate().then(response => {

                if (response) {
                    if (this.model.exames.length === 0) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'Inclua pelo menos um exame para realizar a solicitação.'
                        })
                    }
                    else if (this.data.model.pedidosExames.id && this.data.model.pedidosExames.id !== this.model.id) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'Solicitação de exames já realizada.'
                        })
                    } else {
                        if (!this.model.id) {
                            this.model.id = this.uniqueId('pronto-atendimento-atendimento-medico-exame-sadt')
                        }

                        this.setLoading()

                        this.repositories.dataHora.get({ formato: 'd/m/Y H:i' })
                            .then(data => {

                                this.model.exames[0].dataSolicitacao = data.data

                                this.data.model.pedidosExames = Object.assign({}, this.model)

                                    const index = this.data.form.pedidosExames.findIndex(pedidoExame => pedidoExame.id === this.model.id)

                                    if (index >= 0) {
                                        this.data.form.pedidosExames[index] = this.data.model.pedidosExames
                                    } else {
                                        this.data.form.pedidosExames.push(this.data.model.pedidosExames)
                                    }

                                    this.$emit('saved', this.model)
                            })

                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                }
            })
        },
    },
    mixins: [repository, object],
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
}
</script>

<style scoped>
.rkm-popover {
    min-width: 300px;
}
.rkm-col {
    background-color: #f8f9fa;
}
.rkm-form-checkbox {
    display: flex;
    margin: 0;
    padding: 0;
}
.rkm-form-checkbox >>> .custom-control-label {
    align-self: center;
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.05);
    flex-grow: 1;
    padding-bottom: 0.5rem;
    padding-left: 2rem;
    padding-right: 0.5rem;
    padding-top: 0.5rem;
}
.rkm-form-checkbox >>> .custom-control-label:hover {
    background-color: rgba(0, 0, 0, 0.05);
}
.rkm-form-checkbox >>> .custom-control-label:before {
    left: 0.7rem;
    position: absolute;
    top: 0.7rem;
}
.rkm-form-checkbox >>> .custom-control-label::after {
    left: 0.7rem;
    position: absolute;
    top: 0.7rem;
}
</style>
